export default __webpack_public_path__ + "static/media/icone-site-one-page.fbd358b4.svg";